import api from "@/lib/api";
import { getCashfree } from "@/lib/cashfree";
import { openRazorpayCheckout } from "@/lib/razorpay";

// Unified processing-fee payment. Backend decides the active gateway and returns
// a discriminated payload. Server-side verification is always authoritative.
export async function startProcessingFeePayment() {
  const { data } = await api.post("/payments/create-order");

  if (data.gateway === "razorpay") {
    const resp = await openRazorpayCheckout(data);
    if (resp) {
      await api.post("/payments/razorpay/verify", {
        order_id: data.order_id,
        razorpay_order_id: resp.razorpay_order_id,
        razorpay_payment_id: resp.razorpay_payment_id,
        razorpay_signature: resp.razorpay_signature,
      }).catch(() => {});
    }
    return data.order_id;
  }

  // Default: Cashfree Web Checkout
  const cashfree = await getCashfree(data.mode);
  await cashfree.checkout({ paymentSessionId: data.payment_session_id, redirectTarget: "_modal" });
  return data.order_id;
}
